export default __webpack_public_path__ + "static/media/9c.2fece300.svg";